import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import Button from '../Button';
import Checkmark from '../../svg/icons/checkmark.svg';

import './ListCell.scss';

const ListCell = (props) => {
  const {
    onClick,
    titleText,
    subTitleText,
    iconComponent,
    checkmarkState,
    datadogActionName,
  } = props;

  return (
    <div className="ListCell" data-dd-action-name={datadogActionName}>
      <Button
        className="ListCell__Button"
        variant="no-style"
        onClick={onClick}
        aria-pressed={checkmarkState && checkmarkState.checked}
      >
        <div className="ListCell__IconWrapper">{iconComponent}</div>

        <div className="ListCell__TextContainer">
          <div className="ListCell__HeaderText">{titleText}</div>
          {subTitleText && (
            <div className="ListCell__BodyText">{subTitleText}</div>
          )}
        </div>

        {checkmarkState && (
          <div className="ListCell__CheckmarkContainer">
            {checkmarkState.checked ? (
              <div className="ListCell__Checkmark">
                <Icon
                  fill="#fff"
                  height="20px"
                  width="20px"
                  name="plus"
                  component={Checkmark}
                />
              </div>
            ) : (
              <div className="ListCell__Checkmark_Empty" />
            )}
          </div>
        )}
      </Button>
    </div>
  );
};

ListCell.propTypes = {
  datadogActionName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  titleText: PropTypes.string.isRequired,
  subTitleText: PropTypes.string,
  checkmarkState: PropTypes.shape({
    checked: PropTypes.bool.isRequired,
  }),
  iconComponent: PropTypes.element.isRequired,
};

ListCell.defaultProps = {
  datadogActionName: undefined,
  subTitleText: undefined,
  checkmarkState: undefined,
};

ListCell.displayName = 'ListCell';
export default ListCell;
